var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconConfigureSolid extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconConfigure",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M230.053 453.333H0V240H230.053C275.043 100.733 405.758 0 560 0 714.242 0 844.957 100.733 889.947 240H1920V453.333H889.947C844.957 592.601 714.242 693.333 560 693.333 405.758 693.333 275.043 592.601 230.053 453.333ZM426.667 346.667C426.667 273.029 486.362 213.333 560 213.333 633.638 213.333 693.333 273.029 693.333 346.667 693.333 420.305 633.638 480 560 480 486.362 480 426.667 420.305 426.667 346.667ZM0 853.333H976.72C1021.71 714.066 1152.42 613.333 1306.67 613.333 1460.91 613.333 1591.62 714.066 1636.61 853.333H1920V1066.67H1636.61C1591.62 1205.93 1460.91 1306.67 1306.67 1306.67 1152.42 1306.67 1021.71 1205.93 976.72 1066.67H0V853.333ZM1306.67 826.667C1233.03 826.667 1173.33 886.362 1173.33 960 1173.33 1033.64 1233.03 1093.33 1306.67 1093.33 1380.3 1093.33 1440 1033.64 1440 960 1440 886.362 1380.3 826.667 1306.67 826.667ZM889.947 1680C844.957 1819.27 714.242 1920 560 1920 405.758 1920 275.043 1819.27 230.053 1680H0V1466.67H230.053C275.043 1327.4 405.758 1226.67 560 1226.67 714.242 1226.67 844.957 1327.4 889.947 1466.67H1920V1680H889.947ZM426.667 1573.33C426.667 1499.7 486.362 1440 560 1440 633.638 1440 693.333 1499.7 693.333 1573.33 693.333 1646.97 633.638 1706.67 560 1706.67 486.362 1706.67 426.667 1646.97 426.667 1573.33Z"
      }))
    });
  }
}
IconConfigureSolid.glyphName = 'configure';
IconConfigureSolid.variant = 'Solid';
IconConfigureSolid.displayName = 'IconConfigureSolid';
IconConfigureSolid.allowedProps = [...SVGIcon.allowedProps];
export default IconConfigureSolid;
export { IconConfigureSolid };